module.exports = __webpack_public_path__ + "static/gb-nir-43b61feaa71fe3689833cb76851718a7.svg";